import initialState from "./initialState"
import { SET_USER_DATA, USE_2FA } from '../constants/IAMActionTypes'
import { CLEAR_STORE_DATA, CLEAR_LOGIN_DATA, RECOVER_FROM_ERROR_STATE } from "../constants/ClearStoreActionType";

export default function IAMReducer(state = initialState.iam, action) {
    let newState = JSON.parse(JSON.stringify(state));
    let clean = JSON.parse(JSON.stringify(initialState.iam));

    switch (action.type) {
        case SET_USER_DATA:
            newState.profile = { ...newState.profile, ...action.value }
            return newState

        case USE_2FA:
            newState.use_2fa = action.value
            return newState

        case CLEAR_STORE_DATA:
            return state

        case CLEAR_LOGIN_DATA:
            newState = { ...clean }
            return newState

        case RECOVER_FROM_ERROR_STATE:
            return state

        default: return state;
    }
}
